import React, { useState, useEffect } from 'react';
import {
    Table, Card, Input, Select, Button, Space, Tag, Typography,
    Form, Drawer, Popconfirm, message, DatePicker, Descriptions,
    Radio, Row, Col, Divider
} from 'antd';
import {
    SearchOutlined, ReloadOutlined, PlusOutlined,
    DownloadOutlined, RedoOutlined, CloseCircleOutlined
} from '@ant-design/icons';
import CompileRoleSwitcher, { getCompileRole, setCompileRole, MY_ENTERPRISE, MOCK_ENTERPRISES } from '../CompileRole';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const STATUS_MAP = {
    queued: { text: '排队中', color: 'default' },
    compiling: { text: '编译中', color: 'processing' },
    success: { text: '已完成', color: 'success' },
    failed: { text: '失败', color: 'error' },
    cancelled: { text: '已取消', color: 'default' },
};

// TODO: 联调时替换为接口数据
// buildNo 为运维平台（Jenkins）构建号
// params 为该次发起编译时填写的构建参数（用于构建详情只读展示）
const MOCK_TASKS = [
    {
        id: 'task_20260420_001',
        toolchainName: '海思Hi3516DV300编译链',
        toolchainId: 'tc_001',
        sdkServiceName: '单目',
        tag: 'v3.2.1',
        product: '普通单目云台摄像机',
        productId: 'P5xJS90pll',
        buildNo: '128',
        status: 'success',
        duration: '3分12秒',
        createTime: '2026-04-20 10:30:00',
        enterprise: '东莞康林物联网有限公司',
        params: {
            toolchainLibPath: 'lib',
            category: '摄像机',
            enableWebrtc: 'ON',
            enableGb28181: 'OFF',
            enableOnvif: 'OFF',
            enableRtsp: 'ON',
            enableRf: 'OFF',
            buildLibType: 'STATIC',
            cmakeBuildType: 'Release',
        },
    },
    {
        id: 'task_20260420_002',
        toolchainName: '全志T113编译链',
        toolchainId: 'tc_002',
        sdkServiceName: '双目',
        tag: 'v3.2.1',
        product: 'N2普通云台摄像机',
        productId: 'PfmULRthXq',
        buildNo: '129',
        status: 'compiling',
        duration: '1分45秒',
        createTime: '2026-04-20 11:00:00',
        enterprise: '深圳智联科技有限公司',
        params: {
            toolchainLibPath: 'lib',
            category: '摄像机',
            enableWebrtc: 'OFF',
            enableGb28181: 'ON',
            enableOnvif: 'OFF',
            enableRtsp: 'OFF',
            enableRf: 'OFF',
            buildLibType: 'SHARED',
            cmakeBuildType: 'Release',
        },
    },
    {
        id: 'task_20260419_003',
        toolchainName: '海思Hi3516DV300编译链',
        toolchainId: 'tc_001',
        sdkServiceName: '单目',
        tag: 'v3.2.0',
        product: '普通单目云台摄像机',
        productId: 'P5xJS90pll',
        buildNo: '126',
        status: 'failed',
        duration: '1分05秒',
        createTime: '2026-04-19 14:00:00',
        enterprise: '东莞康林物联网有限公司',
        params: {
            toolchainLibPath: 'lib',
            category: '摄像机',
            enableWebrtc: 'OFF',
            enableGb28181: 'OFF',
            enableOnvif: 'OFF',
            enableRtsp: 'OFF',
            enableRf: 'OFF',
            buildLibType: 'STATIC',
            cmakeBuildType: 'Debug',
        },
    },
    {
        id: 'task_20260419_004',
        toolchainName: '全志T113编译链',
        toolchainId: 'tc_002',
        sdkServiceName: '4G低功耗',
        tag: 'v3.1.5',
        product: '4G低功耗摄像机',
        productId: 'P8kLM2nQwx',
        buildNo: '-',
        status: 'queued',
        duration: '-',
        createTime: '2026-04-20 11:10:00',
        enterprise: '深圳智联科技有限公司',
        params: {
            toolchainLibPath: 'lib',
            category: '4G设备',
            enableWebrtc: 'OFF',
            enableGb28181: 'OFF',
            enableOnvif: 'OFF',
            enableRtsp: 'OFF',
            enableRf: 'ON',
            buildLibType: 'STATIC',
            cmakeBuildType: 'Release',
        },
    },
    {
        id: 'task_20260418_005',
        toolchainName: '海思Hi3516DV300编译链',
        toolchainId: 'tc_001',
        sdkServiceName: '标准NVR',
        tag: 'v3.1.8',
        product: 'N2普通云台摄像机',
        productId: 'PfmULRthXq',
        buildNo: '121',
        status: 'success',
        duration: '4分30秒',
        createTime: '2026-04-18 09:00:00',
        enterprise: '东莞康林物联网有限公司',
        params: {
            toolchainLibPath: 'lib',
            category: 'NVR设备',
            enableWebrtc: 'OFF',
            enableGb28181: 'OFF',
            enableOnvif: 'ON',
            enableRtsp: 'OFF',
            enableRf: 'OFF',
            buildLibType: 'STATIC',
            cmakeBuildType: 'Release',
        },
    },
];

// MOCK: 可用编译链列表（发起编译弹窗用）
// address = 上传文件后平台生成的地址链接，对应 Jenkins 参数 TOOLCHAIN_ROOT
const MOCK_AVAILABLE_TOOLCHAINS = [
    { id: 'tc_001', name: '海思Hi3516DV300编译链', remark: '带NEON优化，适用于DV300量产固件', address: 'https://oss.hmy.com/toolchain/tc_001_hisi3516dv300.tar.gz', enterprise: '东莞康林物联网有限公司' },
    { id: 'tc_002', name: '全志T113编译链', remark: 'glibc版本，支持A53/A55多核', address: 'https://oss.hmy.com/toolchain/tc_002_t113.tar.gz', enterprise: '深圳智联科技有限公司' },
];

// MOCK: 按 IOT 类目关联的SDK服务（产品关联IOT类目 → 类目关联SDK服务）
// tags 由运维平台接口返回；选择 SDK 服务后动态拉取，默认选最新
// 仓库地址不在页面展示，提交时由后端从 SDK 服务取并传给运维平台
const MOCK_SDK_SERVICES_BY_CATEGORY = {
    '摄像机': [
        { id: 'svc_001', name: '单目', tags: ['v3.2.1', 'v3.2.0', 'v3.1.8'] },
        { id: 'svc_002', name: '双目', tags: ['v3.2.1', 'v3.2.0'] },
    ],
    '4G设备': [
        { id: 'svc_004', name: '4G低功耗', tags: ['v3.2.0', 'v3.1.5'] },
    ],
    'NVR设备': [
        { id: 'svc_005', name: '标准NVR', tags: ['v3.1.8', 'v3.1.5'] },
    ],
};

// 发起编译表单：SDK 功能开关（默认 OFF）
const SDK_SWITCH_FIELDS = [
    { name: 'enableWebrtc', label: 'webrtc 开关' },
    { name: 'enableGb28181', label: '国标开关' },
    { name: 'enableOnvif', label: 'onvif 开关' },
    { name: 'enableRtsp', label: 'rtsp 开关' },
    { name: 'enableRf', label: 'RF 射频模块开关' },
];
const ON_OFF_OPTIONS = [{ value: 'ON', label: 'ON' }, { value: 'OFF', label: 'OFF' }];

// category = 产品在「产品开发」中关联的 IOT 类目（产品唯一关联，选择产品后自动带出）
const MOCK_PRODUCTS = [
    { id: 'P5xJS90pll', name: '普通单目云台摄像机', category: '摄像机', enterprise: '东莞康林物联网有限公司' },
    { id: 'PfmULRthXq', name: 'N2普通云台摄像机', category: '摄像机', enterprise: '深圳智联科技有限公司' },
    { id: 'P8kLM2nQwx', name: '4G低功耗摄像机', category: '4G设备', enterprise: '东莞康林物联网有限公司' },
];

// MOCK: 编译日志
const MOCK_LOG = `[2026-04-20 10:30:05] 提交运维平台构建，构建号 #128
[2026-04-20 10:30:05] TOOLCHAIN_ROOT: https://oss.hmy.com/toolchain/tc_001_hisi3516dv300.tar.gz
[2026-04-20 10:30:05] TOOLCHAIN_LIB_PATH: lib
[2026-04-20 10:30:05] TAG: v3.2.1
[2026-04-20 10:30:05] SDK服务: 单目 | 目标产品: 普通单目云台摄像机
[2026-04-20 10:30:05] BUILD_LIB_TYPE: STATIC | CMAKE_BUILD_TYPE: Release | COS_OS: 3
[2026-04-20 10:30:05] ENABLE_WEBRTC: OFF | ENABLE_GB28181: OFF | ENABLE_ONVIF: OFF | ENABLE_RTSP: OFF | ENABLE_RF: OFF
[2026-04-20 10:30:06] 拉取仓库代码，切换 tag: v3.2.1
[2026-04-20 10:30:08] 执行 cmake -DBUILD_LIB_TYPE=STATIC -DCMAKE_BUILD_TYPE=Release ...
[2026-04-20 10:30:10] CC src/core/hmy_sdk_init.c
[2026-04-20 10:30:11] CC src/core/hmy_device.c
[2026-04-20 10:30:12] CC src/p2p/hmy_p2p.c
[2026-04-20 10:30:14] CC src/cloud/hmy_cloud_storage.c
[2026-04-20 10:30:16] CC src/ai/hmy_ai_detect.c
[2026-04-20 10:30:18] CC src/ota/hmy_ota.c
[2026-04-20 10:30:20] WARNING: src/ota/hmy_ota.c:128: 'hmy_ota_legacy_check' is deprecated
[2026-04-20 10:30:22] AR libhmy_sdk.a
[2026-04-20 10:30:26] 生成产物: libhmy_sdk.a (4.1MB)
[2026-04-20 10:30:26] 拷贝头文件: include/hmy_sdk.h, include/hmy_types.h ...
[2026-04-20 10:30:27] 打包产物: hmy_sdk_v3.2.1_hi3516dv300.tar.gz (3.8MB)
[2026-04-20 10:33:12] ✅ 构建成功，总耗时 3分12秒`;

// ══════════════════════════════════════════════
//  子组件：发起编译弹窗
// ══════════════════════════════════════════════

const CreateTaskDrawer = ({ open, onClose, isPlatform, record }) => {
    const [form] = Form.useForm();
    // 再次编译：带原任务记录进入，回显其构建参数后允许修改
    const isRecopy = !!record;
    const [availableServices, setAvailableServices] = useState([]);
    const [tagOptions, setTagOptions] = useState([]);
    const [tagLoading, setTagLoading] = useState(false);
    // 目标产品关联的 IOT 类目（只读展示，产品唯一关联）
    const [category, setCategory] = useState(undefined);

    // 平台角色：先选企业，再展示该企业下的编译链与产品（代企业发起编译）
    const [selectedEnt, setSelectedEnt] = useState(undefined);
    const scopeEnt = isPlatform ? selectedEnt : MY_ENTERPRISE;
    const entToolchains = MOCK_AVAILABLE_TOOLCHAINS.filter(t => t.enterprise === scopeEnt);
    const entProducts = MOCK_PRODUCTS.filter(p => p.enterprise === scopeEnt);

    // 再次编译：按原任务的构建参数回显表单（可修改）
    useEffect(() => {
        if (!open || !record) return;
        const p = record.params || {};
        const services = MOCK_SDK_SERVICES_BY_CATEGORY[p.category] || [];
        const svc = services.find(s => s.name === record.sdkServiceName);
        const tags = svc?.tags || [];
        setSelectedEnt(isPlatform ? record.enterprise : undefined);
        setCategory(p.category);
        setAvailableServices(services);
        setTagOptions(tags);
        setTagLoading(false);
        form.setFieldsValue({
            enterprise: isPlatform ? record.enterprise : undefined,
            toolchainId: record.toolchainId,
            toolchainLibPath: p.toolchainLibPath,
            productId: record.productId,
            sdkServiceId: svc?.id,
            tag: record.tag,
            enableWebrtc: p.enableWebrtc || 'OFF',
            enableGb28181: p.enableGb28181 || 'OFF',
            enableOnvif: p.enableOnvif || 'OFF',
            enableRtsp: p.enableRtsp || 'OFF',
            enableRf: p.enableRf || 'OFF',
            buildLibType: p.buildLibType || 'STATIC',
            cmakeBuildType: p.cmakeBuildType || 'Release',
        });
    }, [open, record, isPlatform, form]);

    const resetState = () => {
        form.resetFields();
        setAvailableServices([]);
        setTagOptions([]);
        setTagLoading(false);
        setCategory(undefined);
        setSelectedEnt(undefined);
    };

    const handleOk = () => {
        form.validateFields().then(() => {
            // TODO: 联调时调用运维平台构建接口，按 Jenkins 映射表转换参数
            // （TOOLCHAIN_ROOT / TOOLCHAIN_LIB_PATH / TAG / COS_OS / BUILD_LIB_TYPE / CMAKE_BUILD_TYPE 及各 ENABLE_* 开关）
            // SDK 源码仓库地址由后端从所选 SDK 服务取并一并传给运维平台（页面不展示）
            message.success(isRecopy ? '已再次提交运维平台构建，构建完成后可下载产物' : '已提交运维平台构建，构建完成后可下载产物');
            resetState();
            onClose();
        });
    };

    const handleEntChange = (val) => {
        form.setFieldsValue({ toolchainId: undefined, toolchainLibPath: undefined, productId: undefined, sdkServiceId: undefined, tag: undefined });
        setAvailableServices([]);
        setTagOptions([]);
        setCategory(undefined);
        setSelectedEnt(val);
    };

    // 选择目标产品 → 自动带出其关联的 IOT 类目 → 按类目关联「上线」状态的 SDK 服务
    const handleProductChange = (val) => {
        const cat = MOCK_PRODUCTS.find(p => p.id === val)?.category;
        form.setFieldsValue({ sdkServiceId: undefined, tag: undefined });
        setCategory(cat);
        setAvailableServices(MOCK_SDK_SERVICES_BY_CATEGORY[cat] || []);
        setTagOptions([]);
    };

    // 选择 SDK 服务 → 调运维平台接口拉取该仓库 TAG 列表，默认选最新
    const handleServiceChange = (val) => {
        const svc = availableServices.find(s => s.id === val);
        form.setFieldsValue({ tag: undefined });
        setTagOptions([]);
        setTagLoading(true);
        // TODO: 联调时改为调用运维平台 TAG 列表接口
        setTimeout(() => {
            const tags = svc?.tags || [];
            setTagOptions(tags);
            form.setFieldsValue({ tag: tags[0] });
            setTagLoading(false);
        }, 400);
    };

    return (
        <Drawer
            title={isRecopy ? '再次编译' : '发起编译'}
            open={open}
            onClose={() => { resetState(); onClose(); }}
            width={600}
            destroyOnClose
            footer={
                <div style={{ textAlign: 'right' }}>
                    <Space>
                        <Button onClick={() => { resetState(); onClose(); }}>取消</Button>
                        <Button type="primary" onClick={handleOk}>提交</Button>
                    </Space>
                </div>
            }
        >
            <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
                <Divider orientation="left" plain style={{ margin: '0 0 12px' }}>基础信息</Divider>
                {isPlatform && (
                    <Form.Item label="所属企业" name="enterprise" rules={[{ required: true, message: '请选择所属企业' }]}>
                        <Select
                            placeholder="请选择企业（代企业发起编译）"
                            showSearch
                            optionFilterProp="label"
                            onChange={handleEntChange}
                            options={MOCK_ENTERPRISES.map(e => ({ value: e, label: e }))}
                        />
                    </Form.Item>
                )}
                <Form.Item label="编译链" name="toolchainId" rules={[{ required: true, message: '请选择编译链' }]}>
                    <Select
                        placeholder={isPlatform && !selectedEnt ? '请先选择所属企业' : '请选择编译链'}
                        disabled={isPlatform && !selectedEnt}
                        showSearch
                        optionFilterProp="label"
                        options={entToolchains.map(tc => ({ value: tc.id, label: `${tc.name}（${tc.id}）` }))}
                    />
                </Form.Item>
                <Form.Item label="编译链内依赖库路径" name="toolchainLibPath">
                    <Input placeholder="编译链内相对路径，如 lib（选填）" />
                </Form.Item>
                <Form.Item label="目标产品" name="productId" rules={[{ required: true, message: '请选择目标产品' }]}>
                    <Select
                        placeholder={isPlatform && !selectedEnt ? '请先选择所属企业' : '请选择产品'}
                        disabled={isPlatform && !selectedEnt}
                        showSearch
                        optionFilterProp="label"
                        onChange={handleProductChange}
                        options={entProducts.map(p => ({ value: p.id, label: `${p.name}（${p.id}）` }))}
                    />
                </Form.Item>
                <Form.Item label="IOT 类目（只读）">
                    <Input value={category || ''} placeholder="选择目标产品后自动带出" readOnly />
                </Form.Item>
                <Form.Item label="SDK服务" name="sdkServiceId" rules={[{ required: true, message: '请选择SDK服务' }]}>
                    <Select
                        placeholder={availableServices.length ? '请选择SDK服务' : (category ? '该IOT类目下暂无可用SDK服务' : '请先选择目标产品')}
                        disabled={!availableServices.length}
                        onChange={handleServiceChange}
                        options={availableServices.map(s => ({ value: s.id, label: s.name }))}
                    />
                </Form.Item>
                <Form.Item label="SDK版本（TAG）" name="tag" rules={[{ required: true, message: '请选择 SDK 版本' }]}>
                    <Select
                        placeholder={tagLoading ? '正在拉取版本列表…' : (tagOptions.length ? '请选择 TAG' : '请先选择 SDK 服务')}
                        disabled={!tagOptions.length}
                        loading={tagLoading}
                        options={tagOptions.map(t => ({ value: t, label: t }))}
                    />
                </Form.Item>

                <Divider orientation="left" plain style={{ margin: '4px 0 12px' }}>SDK 功能开关</Divider>
                <Row gutter={16}>
                    {SDK_SWITCH_FIELDS.map(f => (
                        <Col span={12} key={f.name}>
                            <Form.Item label={f.label} name={f.name} initialValue="OFF">
                                <Radio.Group size="small" optionType="button" buttonStyle="solid" options={ON_OFF_OPTIONS} />
                            </Form.Item>
                        </Col>
                    ))}
                </Row>

                <Divider orientation="left" plain style={{ margin: '4px 0 12px' }}>编译选项</Divider>
                <Form.Item label="静态/动态库编译" name="buildLibType" initialValue="STATIC">
                    <Radio.Group size="small" optionType="button" buttonStyle="solid" options={[
                        { value: 'STATIC', label: 'STATIC（静态库，默认）' },
                        { value: 'SHARED', label: 'SHARED（动态库）' },
                    ]} />
                </Form.Item>
                <Form.Item label="构建类型" name="cmakeBuildType" initialValue="Release">
                    <Radio.Group size="small" optionType="button" buttonStyle="solid" options={[
                        { value: 'Release', label: 'Release（默认）' },
                        { value: 'Debug', label: 'Debug（调试库）' },
                    ]} />
                </Form.Item>
                <div style={{ background: '#f9f9f9', padding: 12, borderRadius: 8, fontSize: 12, color: '#666' }}>
                    适配层当前仅支持 Linux，系统自动传递 COS_OS=3，无需选择。
                </div>
            </Form>
        </Drawer>
    );
};

// ══════════════════════════════════════════════
//  子组件：编译日志抽屉
// ══════════════════════════════════════════════

const LogDrawer = ({ open, record, onClose }) => {
    const [searchKey, setSearchKey] = useState('');

    if (!record) return null;

    const highlightLog = (log) => {
        return log.split('\n').map((line, i) => {
            let color = '#d4d4d4';
            if (line.includes('ERROR') || line.includes('❌')) color = '#ff4d4f';
            else if (line.includes('WARNING')) color = '#faad14';
            else if (line.includes('✅')) color = '#52c41a';

            if (searchKey && line.toLowerCase().includes(searchKey.toLowerCase())) {
                return <div key={i} style={{ color, background: '#3a3a00', padding: '2px 4px' }}>{line}</div>;
            }
            return <div key={i} style={{ color }}>{line}</div>;
        });
    };

    return (
        <Drawer
            title="编译日志"
            open={open}
            onClose={onClose}
            width={720}
        >
            {/* 摘要 */}
            <div style={{ marginBottom: 16 }}>
                <Space>
                    <Text strong>{record.id}</Text>
                    <Tag color={STATUS_MAP[record.status]?.color}>{STATUS_MAP[record.status]?.text}</Tag>
                </Space>
                <div style={{ marginTop: 8, fontSize: 13, color: '#666' }}>
                    {record.toolchainName} → {record.sdkServiceName} ({record.tag}) → {record.product}
                </div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                    构建号：{record.buildNo && record.buildNo !== '-' ? `#${record.buildNo}` : '-'} | 创建时间：{record.createTime} | 耗时：{record.duration}
                </div>
            </div>

            {/* 搜索 */}
            <Input
                placeholder="搜索日志内容"
                prefix={<SearchOutlined />}
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
                allowClear
                style={{ marginBottom: 12 }}
            />

            {/* 日志区域 */}
            <div style={{
                background: '#1e1e1e',
                borderRadius: 8,
                padding: 16,
                fontFamily: 'Menlo, Monaco, Consolas, monospace',
                fontSize: 12,
                lineHeight: 1.8,
                maxHeight: 'calc(100vh - 320px)',
                overflow: 'auto',
            }}>
                {highlightLog(MOCK_LOG)}
            </div>

            {/* 底部操作 */}
            <div style={{ marginTop: 12 }}>
                <Space>
                    <Button size="small" icon={<DownloadOutlined />}>下载完整日志</Button>
                </Space>
            </div>
        </Drawer>
    );
};

// ══════════════════════════════════════════════
//  子组件：构建详情抽屉（只读展示发起编译时的参数）
// ══════════════════════════════════════════════

const TaskDetailDrawer = ({ open, record, onClose, isPlatform }) => {
    if (!record) return null;

    const params = record.params || {};

    return (
        <Drawer title="构建详情" open={open} onClose={onClose} width={520}>
            <div style={{ marginBottom: 16 }}>
                <Space>
                    <Text strong>{record.id}</Text>
                    <Tag color={STATUS_MAP[record.status]?.color}>{STATUS_MAP[record.status]?.text}</Tag>
                </Space>
                <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                    创建时间：{record.createTime} | 耗时：{record.duration}
                </div>
            </div>

            <Descriptions bordered column={1} size="small">
                {isPlatform && <Descriptions.Item label="所属企业">{record.enterprise}</Descriptions.Item>}
                <Descriptions.Item label="编译链">{record.toolchainName}（{record.toolchainId}）</Descriptions.Item>
                <Descriptions.Item label="编译链内依赖库路径">{params.toolchainLibPath || '-'}</Descriptions.Item>
                <Descriptions.Item label="目标产品">{record.product}（{record.productId}）</Descriptions.Item>
                <Descriptions.Item label="IOT 类目">{params.category || '-'}</Descriptions.Item>
                <Descriptions.Item label="SDK服务">{record.sdkServiceName}</Descriptions.Item>
                <Descriptions.Item label="SDK版本（TAG）">{record.tag}</Descriptions.Item>
                <Descriptions.Item label="构建号">
                    {record.buildNo && record.buildNo !== '-' ? `#${record.buildNo}` : '-'}
                </Descriptions.Item>
            </Descriptions>

            <Title level={5} style={{ marginTop: 20 }}>SDK 功能开关</Title>
            <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="webrtc 开关">{params.enableWebrtc || 'OFF'}</Descriptions.Item>
                <Descriptions.Item label="国标开关">{params.enableGb28181 || 'OFF'}</Descriptions.Item>
                <Descriptions.Item label="onvif 开关">{params.enableOnvif || 'OFF'}</Descriptions.Item>
                <Descriptions.Item label="rtsp 开关">{params.enableRtsp || 'OFF'}</Descriptions.Item>
                <Descriptions.Item label="RF 射频模块开关">{params.enableRf || 'OFF'}</Descriptions.Item>
            </Descriptions>

            <Title level={5} style={{ marginTop: 20 }}>编译选项</Title>
            <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="静态/动态库编译">{params.buildLibType || 'STATIC'}</Descriptions.Item>
                <Descriptions.Item label="构建类型">{params.cmakeBuildType || 'Release'}</Descriptions.Item>
                <Descriptions.Item label="适配层系统">Linux（COS_OS=3）</Descriptions.Item>
            </Descriptions>

            <div style={{ marginTop: 16, background: '#f9f9f9', padding: 12, borderRadius: 8, fontSize: 12, color: '#666' }}>
                编译链地址（TOOLCHAIN_ROOT）与 SDK 源码仓库地址由平台随构建参数传给运维平台，不在页面展示。
            </div>
        </Drawer>
    );
};

// ══════════════════════════════════════════════
//  主组件：编译任务列表
// ══════════════════════════════════════════════

const CompileTask = () => {
    const [role, setRole] = useState(getCompileRole());
    const isPlatform = role === 'platform';

    const [createOpen, setCreateOpen] = useState(false);
    const [createRecord, setCreateRecord] = useState(null);
    const [logOpen, setLogOpen] = useState(false);
    const [detailOpen, setDetailOpen] = useState(false);
    const [detailRecord, setDetailRecord] = useState(null);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [searchToolchain, setSearchToolchain] = useState(undefined);
    const [searchStatus, setSearchStatus] = useState(undefined);
    const [searchEnterprise, setSearchEnterprise] = useState(undefined);
    const [searchRange, setSearchRange] = useState(null);
    const [, setPollTick] = useState(0);

    // TODO: 联调时改为轮询运维平台构建状态接口，用返回值刷新任务状态、构建号与日志
    useEffect(() => {
        const timer = setInterval(() => setPollTick(t => t + 1), 10000);
        return () => clearInterval(timer);
    }, []);

    const handleRoleChange = (next) => {
        setCompileRole(next); // 模块内共用，切换后其它页面保持一致
        setRole(next);
    };

    const handleCancel = (record) => {
        message.success(`已取消编译任务：${record.id}`);
    };

    // 编译链筛选项：企业角色仅本企业；平台角色随「所属企业」筛选联动
    const toolchainOptions = isPlatform
        ? (searchEnterprise ? MOCK_AVAILABLE_TOOLCHAINS.filter(t => t.enterprise === searchEnterprise) : MOCK_AVAILABLE_TOOLCHAINS)
        : MOCK_AVAILABLE_TOOLCHAINS.filter(t => t.enterprise === MY_ENTERPRISE);

    // 角色数据范围：企业角色仅本企业；平台角色可见全部，可按企业筛选
    const dataSource = MOCK_TASKS.filter((task) => {
        if (!isPlatform && task.enterprise !== MY_ENTERPRISE) return false;
        if (isPlatform && searchEnterprise && task.enterprise !== searchEnterprise) return false;
        if (searchToolchain && task.toolchainId !== searchToolchain) return false;
        if (searchStatus && task.status !== searchStatus) return false;
        if (searchRange && searchRange.length === 2) {
            const start = searchRange[0].format('YYYY-MM-DD 00:00:00');
            const end = searchRange[1].format('YYYY-MM-DD 23:59:59');
            if (task.createTime < start || task.createTime > end) return false;
        }
        return true;
    });

    const columns = [
        {
            title: '任务ID',
            dataIndex: 'id',
            width: 180,
            render: (text) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{text}</Text>,
        },
        ...(isPlatform ? [{
            title: '所属企业',
            dataIndex: 'enterprise',
            width: 180,
        }] : []),
        {
            title: '编译链',
            dataIndex: 'toolchainName',
            width: 180,
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{text}</div>
                    <Text copyable style={{ fontFamily: 'monospace', fontSize: 12, color: '#999' }}>{record.toolchainId}</Text>
                </div>
            ),
        },
        { title: 'SDK服务', dataIndex: 'sdkServiceName', width: 100 },
        { title: 'SDK版本（TAG）', dataIndex: 'tag', width: 130 },
        {
            title: '目标产品',
            dataIndex: 'product',
            width: 160,
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{text}</div>
                    <div style={{ fontSize: 12, color: '#999' }}>{record.productId}</div>
                </div>
            ),
        },
        {
            title: '构建号',
            dataIndex: 'buildNo',
            width: 100,
            render: (text, record) => (text && text !== '-')
                ? (
                    <Button
                        type="link"
                        style={{ padding: 0 }}
                        onClick={() => { setDetailRecord(record); setDetailOpen(true); }}
                    >
                        #{text}
                    </Button>
                )
                : <span style={{ color: '#ccc' }}>-</span>,
        },
        {
            title: '状态',
            dataIndex: 'status',
            width: 90,
            render: (s) => <Tag color={STATUS_MAP[s]?.color} style={{ border: 'none' }}>{STATUS_MAP[s]?.text}</Tag>,
        },
        {
            title: '耗时',
            dataIndex: 'duration',
            width: 100,
            render: (text, record) => {
                if (record.status === 'compiling') return <Text type="warning">{text}（进行中）</Text>;
                if (text === '-') return <span style={{ color: '#ccc' }}>-</span>;
                return text;
            },
        },
        { title: '创建时间', dataIndex: 'createTime', width: 170 },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                // 平台角色可代企业操作（数据范围为全平台）
                <Space>
                    {['compiling', 'success', 'failed'].includes(record.status) && (
                        <Button type="link" size="small" onClick={() => { setCurrentRecord(record); setLogOpen(true); }}>日志</Button>
                    )}
                    {record.status === 'success' && (
                        <Button type="link" size="small" icon={<DownloadOutlined />} onClick={() => message.success(`正在生成产物下载链接：${record.id}`)}>下载</Button>
                    )}
                    {['failed', 'success'].includes(record.status) && (
                        <Button type="link" size="small" icon={<RedoOutlined />} onClick={() => { setCreateRecord(record); setCreateOpen(true); }}>再次编译</Button>
                    )}
                    {['queued', 'compiling'].includes(record.status) && (
                        <Popconfirm title="确定取消该编译任务？" onConfirm={() => handleCancel(record)}>
                            <Button type="link" size="small" danger icon={<CloseCircleOutlined />}>取消</Button>
                        </Popconfirm>
                    )}
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Space align="baseline" size={8}>
                    <Title level={4} style={{ margin: 0 }}>编译任务</Title>
                    <Text type="secondary" style={{ fontSize: 12 }}>任务状态与日志每 10 秒自动刷新</Text>
                </Space>
                <CompileRoleSwitcher role={role} onChange={handleRoleChange} />
            </div>

            {/* 筛选区 */}
            <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space wrap>
                        {isPlatform && (
                            <Select
                                placeholder="所属企业"
                                value={searchEnterprise}
                                onChange={(val) => { setSearchEnterprise(val); setSearchToolchain(undefined); }}
                                style={{ width: 200 }}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                options={MOCK_ENTERPRISES.map(e => ({ value: e, label: e }))}
                            />
                        )}
                        <Select
                            placeholder="编译链"
                            value={searchToolchain}
                            onChange={setSearchToolchain}
                            style={{ width: 240 }}
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            options={toolchainOptions.map(tc => ({ value: tc.id, label: `${tc.name}（${tc.id}）` }))}
                        />
                        <Select
                            placeholder="状态"
                            value={searchStatus}
                            onChange={setSearchStatus}
                            style={{ width: 120 }}
                            allowClear
                            options={Object.entries(STATUS_MAP).map(([k, v]) => ({ value: k, label: v.text }))}
                        />
                        <RangePicker value={searchRange} onChange={setSearchRange} placeholder={['开始时间', '结束时间']} />
                        <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                        <Button icon={<ReloadOutlined />} onClick={() => { setSearchToolchain(undefined); setSearchStatus(undefined); setSearchEnterprise(undefined); setSearchRange(null); }}>重置</Button>
                    </Space>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => { setCreateRecord(null); setCreateOpen(true); }}>新建任务</Button>
                </div>
            </Card>

            {/* 表格 */}
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="id"
                    scroll={{ x: 'max-content' }}
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                />
            </Card>

            <CreateTaskDrawer open={createOpen} isPlatform={isPlatform} record={createRecord} onClose={() => setCreateOpen(false)} />
            <LogDrawer open={logOpen} record={currentRecord} onClose={() => setLogOpen(false)} />
            <TaskDetailDrawer open={detailOpen} record={detailRecord} isPlatform={isPlatform} onClose={() => setDetailOpen(false)} />
        </div>
    );
};

export default CompileTask;
